import useSWRInfinite, { type SWRInfiniteResponse } from 'swr/infinite'

import {
  type PaginatedBrandsResult,
  SellerCentralControllerV2ApiFactory,
} from '@redteclab/api/clients/bully'

import { useGlooApi } from '../../../api'
import { useGlobalConfigContext } from '../../../global-config'
import { type TENANT_AND_ENV } from '../../../tenant'

export const useMarketplacePartnerRegisterPageFormApiGetBrands = (
  limit = 100,
): SWRInfiniteResponse<PaginatedBrandsResult> => {
  const config = useGlobalConfigContext()
  const client = useGlooApi(SellerCentralControllerV2ApiFactory)

  type KeyObject = {
    key: string
    language: string
    limit: number
    page: number
    tenant: TENANT_AND_ENV
  }

  const getKey = (
    pageIndex: number,
    previousPageData?: PaginatedBrandsResult,
  ): KeyObject | null => {
    if (previousPageData && !previousPageData.hasNext) {
      return null
    }

    return {
      key: 'marketplacePartnerRegisterPageGetBrandsInfinite',
      language: config.language,
      limit,
      page: pageIndex + 1,
      tenant: config.tenantAndEnv,
    }
  }

  const fetcher = async (key: KeyObject): Promise<PaginatedBrandsResult> => {
    const response = await client.getAllBrands({
      language: key.language,
      limit: key.limit,
      page: key.page,
      tenant: key.tenant,
    })

    return response.data
  }

  return useSWRInfinite(getKey, fetcher, {
    revalidateFirstPage: false,
  })
}
